import { FC } from 'react';
import { SvgProps } from '../interfaces/Icon';

const WithdrawWallet: FC<SvgProps> = ({ size, className, color }) => {
  return (
    <svg
      width="47"
      height="45"
      viewBox="0 0 47 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        y="5"
        width="40"
        height="40"
        rx="20"
        fill="#F7F7F7"
        fillOpacity="0.05"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1667 21.6667C13.9457 21.6667 13.7338 21.7545 13.5775 21.9107C13.4212 22.067 13.3334 22.279 13.3334 22.5V30C13.3334 30.221 13.4212 30.433 13.5775 30.5893C13.7338 30.7455 13.9457 30.8333 14.1667 30.8333H25.8334C26.0544 30.8333 26.2664 30.7455 26.4227 30.5893C26.579 30.433 26.6667 30.221 26.6667 30V22.5C26.6667 22.279 26.579 22.067 26.4227 21.9107C26.2664 21.7545 26.0544 21.6667 25.8334 21.6667H14.1667ZM12.399 20.7322C12.8678 20.2634 13.5037 20 14.1667 20H25.8334C26.4965 20 27.1323 20.2634 27.6012 20.7322C28.07 21.2011 28.3334 21.837 28.3334 22.5V30C28.3334 30.663 28.07 31.2989 27.6012 31.7678C27.1323 32.2366 26.4965 32.5 25.8334 32.5H14.1667C13.5037 32.5 12.8678 32.2366 12.399 31.7678C11.9301 31.2989 11.6667 30.663 11.6667 30V22.5C11.6667 21.837 11.9301 21.2011 12.399 20.7322Z"
        fill="#F7F7F7"
      />
      <path
        d="M23.7499 26.6666C23.6394 26.6666 23.5334 26.6227 23.4553 26.5445C23.3772 26.4664 23.3333 26.3604 23.3333 26.2499C23.3333 26.1394 23.3772 26.0334 23.4553 25.9553C23.5334 25.8772 23.6394 25.8333 23.7499 25.8333C23.8604 25.8333 23.9664 25.8772 24.0445 25.9553C24.1227 26.0334 24.1666 26.1394 24.1666 26.2499C24.1666 26.3604 24.1227 26.4664 24.0445 26.5445C23.9664 26.6227 23.8604 26.6666 23.7499 26.6666Z"
        fill="#F7F7F7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.7499 26.4583C23.8052 26.4583 23.8582 26.4363 23.8972 26.3972C23.9363 26.3582 23.9583 26.3052 23.9583 26.2499C23.9583 26.1947 23.9363 26.1417 23.8972 26.1026C23.8582 26.0635 23.8052 26.0416 23.7499 26.0416C23.6947 26.0416 23.6417 26.0635 23.6026 26.1026C23.5635 26.1417 23.5416 26.1947 23.5416 26.2499C23.5416 26.3052 23.5635 26.3582 23.6026 26.3972C23.6417 26.4363 23.6947 26.4583 23.7499 26.4583ZM23.0133 25.5133C23.2087 25.318 23.4737 25.2083 23.7499 25.2083C24.0262 25.2083 24.2911 25.318 24.4865 25.5133C24.6818 25.7087 24.7916 25.9737 24.7916 26.2499C24.7916 26.5262 24.6818 26.7911 24.4865 26.9865C24.2911 27.1818 24.0262 27.2916 23.7499 27.2916C23.4737 27.2916 23.2087 27.1818 23.0133 26.9865C22.818 26.7911 22.7083 26.5262 22.7083 26.2499C22.7083 25.9737 22.818 25.7087 23.0133 25.5133Z"
        fill="#F7F7F7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.6897 17.254C23.0599 17.1553 23.4478 17.1431 23.8235 17.2182C24.1992 17.2933 24.5526 17.4537 24.8564 17.6871C25.1602 17.9205 25.4063 18.2206 25.5757 18.5643C25.7451 18.9079 25.8333 19.2859 25.8334 19.669V20.8334H24.1667V19.6694C24.1667 19.6694 24.1667 19.6695 24.1667 19.6694C24.1667 19.5418 24.1373 19.4157 24.0809 19.3012C24.0244 19.1867 23.9423 19.0866 23.8411 19.0088C23.7398 18.931 23.622 18.8775 23.4968 18.8525C23.3716 18.8275 23.2423 18.8316 23.1189 18.8644C23.1189 18.8644 23.119 18.8644 23.1189 18.8644L13.9523 21.3086C13.7748 21.3559 13.6178 21.4605 13.5059 21.6062C13.394 21.7518 13.3334 21.9304 13.3334 22.114V22.5H11.6667V22.1144C11.6667 22.1143 11.6667 22.1145 11.6667 22.1144C11.6667 21.5634 11.8486 21.0277 12.1842 20.5908C12.5199 20.1539 12.9905 19.8401 13.5229 19.6982C13.5228 19.6982 13.5229 19.6982 13.5229 19.6982L22.6897 17.254Z"
        fill="#F7F7F7"
      />
      <g filter="url(#filter0_b_371_2853)">
        <ellipse
          cx="33.3333"
          cy="13.3333"
          rx="13.3333"
          ry="13.3333"
          fill="#F7F7F7"
          fillOpacity="0.05"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.5709 8.14024C30.8693 7.84192 31.3529 7.84192 31.6512 8.14024L34.3248 10.8139C34.6232 11.1122 34.6232 11.5958 34.3248 11.8942C34.0265 12.1925 33.5429 12.1925 33.2445 11.8942L31.1111 9.76069L28.9776 11.8942C28.6793 12.1925 28.1956 12.1925 27.8973 11.8942C27.599 11.5958 27.599 11.1122 27.8973 10.8139L30.5709 8.14024Z"
        fill="#F7F7F7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.1111 7.9165C31.533 7.9165 31.875 8.25851 31.875 8.68039V13.2637C31.875 13.8715 32.1164 14.4544 32.5462 14.8842C32.976 15.3139 33.5589 15.5554 34.1666 15.5554H39.5139C39.9357 15.5554 40.2778 15.8974 40.2778 16.3193C40.2778 16.7412 39.9357 17.0832 39.5139 17.0832H34.1666C33.1537 17.0832 32.1822 16.6808 31.4659 15.9645C30.7496 15.2482 30.3472 14.2767 30.3472 13.2637V8.68039C30.3472 8.25851 30.6892 7.9165 31.1111 7.9165Z"
        fill="#F7F7F7"
      />
      <defs>
        <filter
          id="filter0_b_371_2853"
          x="5"
          y="-15"
          width="56.6667"
          height="56.6667"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="7.5" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_371_2853"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_371_2853"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default WithdrawWallet;
